import { render } from "./ShortFields.vue?vue&type=template&id=80b03a6e"
import script from "./ShortFields.vue?vue&type=script&lang=js"
export * from "./ShortFields.vue?vue&type=script&lang=js"

import "./ShortFields.vue?vue&type=style&index=0&id=80b03a6e&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__